import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button, Checkbox, FormControlLabel } from "@material-ui/core";
import BreadCrumbNav from "../BreadCrumbNav";
import { getUser } from "../../helpers";
import { format, utcToZonedTime } from 'date-fns-tz';

import "./Stamp.css";

const timeZoneToLocationMap = {
  "Asia/Tokyo": "日本",
  "Asia/Ho_Chi_Minh": "ベトナム",
  "America/New_York": "アメリカ（ニューヨーク州）",
  "Asia/Bangkok": "タイ",
  "Asia/Shanghai": "中国",
};

const japaneseDaysOfWeek = {
  'Monday': '月',
  'Tuesday': '火',
  'Wednesday': '水',
  'Thursday': '木',
  'Friday': '金',
  'Saturday': '土',
  'Sunday': '日',
};

class Stamp extends Component {
   constructor(props) {
      super(props);
      this.state = {
         confirmDialog: false,
         selectedUser: {},
         offset: 0,
         limit: 50,
         date: null,
         tabValue: 0,
         data: [],
         i_num: -1,
         inputName: "",
         department_id: -1,
         checkedDelete: false,
         openAlert: false,
         editSuccess: false,
         currentTime: new Date(),
         isStampEnabled: false,
         stampAction: null, 
         showStampMessage: false,
      };
   }

   componentDidMount() {
      const user = getUser();
      const { getUserAccount } = this.props;
      
      const login_email=user.login_email
      const params = {
        login_email:login_email
        //  offset: this.state.offset * this.state.limit,
        //  limit: this.state.limit,
      };
      getUserAccount(params);

      this.timer = setInterval(() => {
        this.setState({
           currentTime: new Date(),
        });
     }, 1000);
   }

   componentWillUnmount() {
    clearInterval(this.timer);
   }

   handleCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    let { stampAction } = this.state;
  
    if (isChecked && !stampAction) {
      const currentHour = new Date().getHours();
      stampAction = currentHour < 12 ? 'checkIn' : 'checkOut';
    }
  
    this.setState({
      isStampEnabled: isChecked,
      stampAction: stampAction,
    });
  }

   selectStampAction = (action) => {
    this.setState({ stampAction: action });
    }
   render() {
      const user = getUser();
      const {
         items,
      } = this.props;
      // console.log(items);
      const userTimeZone = items && items.detailData 
      ? items.detailData[0].time_zone || ''
      : '';
      // const userTimeZone = items && items.detailData 
      // ? items.detailData.find(item => item.login_email === user.login_email)?.time_zone || ''
      // : '';
      
      const locationInJapanese = timeZoneToLocationMap[userTimeZone] || '';
      const isTimeZoneValid = userTimeZone && userTimeZone !== "None";
      const currentTimeZone = isTimeZoneValid ? userTimeZone : Intl.DateTimeFormat().resolvedOptions().timeZone;
      const currentTime = utcToZonedTime(new Date(), currentTimeZone);
      const japaneseDayOfWeek = japaneseDaysOfWeek[format(currentTime, 'EEEE', { timeZone: currentTimeZone })];
      // Format date and time
      const formattedDate = format(currentTime, `yyyy/MM/dd ('${japaneseDayOfWeek}')`, { timeZone: currentTimeZone });
      const formattedTime = format(currentTime, 'HH:mm:ss', { timeZone: currentTimeZone });
      
      const isMorning = currentTime.getHours() >= 0 && currentTime.getHours() < 12;
      const isAfternoon = currentTime.getHours() >= 12 && currentTime.getHours() < 24;

      const handleStampButtonClick = () => {
        const { sendTimekeeping } = this.props;
        const formattedTimePost = format(this.state.currentTime, 'yyyy-MM-dd HH:mm:ss');
        const { stampAction} = this.state;

        let timekeepingData = {
          process_type: "saveTimekeeping",
          time_zone: userTimeZone,
        };

        if (stampAction === 'checkIn') {
          timekeepingData.work_time = formattedTimePost;
        } else if (stampAction === 'checkOut') {
          timekeepingData.leave_work_time = formattedTimePost;
        }

        sendTimekeeping(timekeepingData);
        this.setState({ isStampEnabled: false, stampAction: null, showStampMessage: true });

        setTimeout(() => {
          this.setState({ showStampMessage: false });
        }, 3000); 
      };

      const isLocationSelected = !!timeZoneToLocationMap[userTimeZone];
      let workButtonClass = 'work-button';
      let leavingButtonClass = 'leaving-button';

      if (this.state.stampAction === 'checkIn') {
        workButtonClass += ' button-large';
        leavingButtonClass += ' button-small';
      } else if (this.state.stampAction === 'checkOut') {
        workButtonClass += ' button-small';
        leavingButtonClass += ' button-large';
      } else {
        workButtonClass += isMorning ? ' button-large' : ' button-small';
        leavingButtonClass += isAfternoon ? ' button-large' : ' button-small';
      }

      return (
        <div className="content-container">
          <BreadCrumbNav screenName="打刻"></BreadCrumbNav>
          <div className="loginname">ログイン名：{user.username}</div>
          <div className="stamp-container">
            <div className="time-row">
              <div className="datetime">
                <div className="date">{formattedDate}</div>
              </div>

              <div className="current-time">{formattedTime}</div>
              <div className="word-location">勤務地：{locationInJapanese}</div>
            </div>

            <div className="button-row">
            <Button
              variant="outlined"
              className={workButtonClass}
              disabled={!isLocationSelected}
              onClick={() => this.selectStampAction('checkIn')}
            >
              出勤
            </Button>

            <Button
              variant="outlined"
              className={leavingButtonClass}
              disabled={!isLocationSelected}
              onClick={() => this.selectStampAction('checkOut')}
            >
              退勤
            </Button>
            </div>

            <div className="checkbox-row">
              <FormControlLabel
                control={<Checkbox name="checkedBreak" checked={this.state.isStampEnabled} onChange={this.handleCheckboxChange} disabled={!isLocationSelected}/>}
                label="打刻します"
              />

              <Button
                className="break-button"
                disabled={!this.state.isStampEnabled || !isLocationSelected}
                onClick={handleStampButtonClick}
              >
                打刻
              </Button>
            </div>
          </div>
          <div className="stamp-message">
            {this.state.showStampMessage && <span>打刻しました</span>}
          </div>       
        </div>
      );
   }
}

Stamp.propTypes = {
   getUserAccount: PropTypes.func.isRequired,
   sendTimekeeping: PropTypes.func.isRequired,
};

export default Stamp;
